/**
 * @file: ThreadListSkeleton.tsx
 *
 * Placeholder rows shown while the inbox thread list is loading for the first
 * time — avoids flashing the "暂无消息" empty state before the fetch resolves.
 * Mirrors `ChatThreadRow`'s layout (avatar + title + preview) so the swap to
 * real rows doesn't shift.
 */

import { SkeletonBar } from '@euler/app/components/task-card/components/SkeletonBar';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import { View } from 'react-native';

const ROW_COUNT = 12;
// The feed (通知) list's placeholder grey: the inbox's two tabs load alike.
const SKELETON_COLOR = '#EAEDF2';

const ThreadRowSkeleton: FC = memo(() => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: rpx(12),
        paddingHorizontal: rpx(16),
      }}
    >
      <View style={{ marginRight: rpx(12) }}>
        <SkeletonBar width={rpx(44)} height={rpx(44)} color={SKELETON_COLOR} />
      </View>
      <View style={{ flex: 1 }}>
        <SkeletonBar width={rpx(120)} height={rpx(14)} color={SKELETON_COLOR} />
        <View style={{ height: rpx(8) }} />
        <SkeletonBar width={rpx(200)} height={rpx(12)} color={SKELETON_COLOR} />
      </View>
    </View>
  );
});

export const ThreadListSkeleton: FC = memo(() => {
  const { rpx } = useResponsiveContext();
  return (
    <View style={{ paddingTop: rpx(16) }}>
      {Array.from({ length: ROW_COUNT }).map((_, i) => (
        <ThreadRowSkeleton key={i} />
      ))}
    </View>
  );
});
